import * as v from 'valibot';
import { attributeSchema } from '../types/Zigbee/Attribute';
import { endpointSchema } from '../types/Zigbee/Endpoint';
import { nodeDescriptorSchema } from '../types/Zigbee/NodeDescriptor';
import { clusterIdSchema, endpointIdSchema } from '../util/valibot';
import { reportingSchema } from './Zigbee/Reporting';
export const clusterAttributesSchema = v.object({
    attributes: v.array(attributeSchema),
    cluster_id: clusterIdSchema,
});
export const endpointClusterAttributesSchema = v.object({
    clusters: v.array(clusterAttributesSchema),
    endpoint: endpointIdSchema,
});
export const zigbeeDeviceInfoInputSchema = v.object({
    node_descriptor: v.optional(nodeDescriptorSchema),
    attributes: v.array(endpointClusterAttributesSchema),
    endpoints: v.array(endpointSchema),
    reporting: v.optional(reportingSchema),
});
export const zigbeeDeviceInfoSchema = v.pipe(zigbeeDeviceInfoInputSchema, v.transform((o) => {
    const endpoints = {};
    for (const e of o.endpoints) {
        endpoints[e.endpoint] = e;
    }
    const attributes = {};
    for (const a of o.attributes) {
        if (!(a.endpoint in attributes)) {
            attributes[a.endpoint] = {};
        }
        for (const c of a.clusters) {
            if (!(c.cluster_id in attributes[a.endpoint])) {
                attributes[a.endpoint][c.cluster_id] = {};
            }
            for (const a2 of c.attributes) {
                attributes[a.endpoint][c.cluster_id][a2.attribute_id] = a2;
            }
        }
    }
    return { node_descriptor: o.node_descriptor,
        endpoints,
        attributes,
        reporting: o.reporting };
}));
